import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  group,
  animateChild,
} from '@angular/animations';
import { Router } from '@angular/router';
import { Subscription, forkJoin, Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { COMMON_CONSTANTS } from 'src/app/common/constants/common-constants';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatbotService } from 'src/app/common/services/chatbot.service';
//import { MsalService } from '@azure/msal-angular';
import { protectedResources } from 'src/app/auth.config';
import { ClientssoService } from 'src/app/common/services/clientsso.service';

interface Client {
  ClientName: string;
  showStudies: boolean;
  UniqueStudies: string[];
}
interface Snapshot {
  type: string;
  name: string;
  section: string;
  subSection: string;
}

interface DisplaySnapshotTile {
  snapshotName: string;
  studyName: string;
  category: string;
  bucket: string;
  displayLabel: string;
  navSnapshotType: string;
  navSection: string;
  navSubSection: string;
  sort_id:number;
}

interface DisplayBucketGroup {
  bucketName: string;
  tiles: DisplaySnapshotTile[];
  sort_id:number;
}

@Component({
  selector: 'app-module-tile-landing',
  templateUrl: './module-tile-landing.component.html',
  styleUrls: ['./module-tile-landing.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    /* Simpler state-based animation to avoid overlapping text during page changes */
    trigger('tabSlide', [
      transition(':increment', [
        style({ transform: 'translateX(26px)', opacity: 0 }),
        animate(
          '130ms ease-out',
          style({ transform: 'translateX(0)', opacity: 1 }),
        ),
      ]),
      transition(':decrement', [
        style({ transform: 'translateX(-26px)', opacity: 0 }),
        animate(
          '130ms ease-out',
          style({ transform: 'translateX(0)', opacity: 1 }),
        ),
      ]),
    ]),
  ],
})
export class ModuleTileLandingComponent implements OnDestroy {
  private resizeHandler = () => this.updateVisibleCount();

  // Used for template to control arrow visibility
  get totalSnapshots(): number {
    return this.filteredStudyNamesArray?.length || 0;
  }

  /** Display-only landing layout (category tabs → bucket headers → snapshot tiles) */
  readonly categoryDisplayOrder = ['Brand Tracker', 'Product Tracker'];
  readonly bucketDisplayOrder = ['All Business Lines', 'Business Line Specific'];
  displayCategoryTabs: string[] = [];
  filteredDisplayCategoryTabs: string[] = [];
  displayCategoryTabsCount = 0;
  activeDisplayCategory = '';
  displayLandingGroups: DisplayBucketGroup[] = [];
  allConfiguredSnapshots: any[] = [];
  allConfiguredSnapshotsRaw: any[] = [];
  displayCategoryPageIndex = 0;
  useDisplayLandingLayout = true;

  get totalDisplayCategories(): number {
    return this.filteredDisplayCategoryTabs?.length || 0;
  }

  get visibleDisplayCategoryTabs(): string[] {
    const start = this.displayCategoryPageIndex * this.visibleCount;
    return this.filteredDisplayCategoryTabs.slice(
      start,
      start + this.visibleCount,
    );
  }

  get canShowDisplayCategoryPrev(): boolean {
    return this.displayCategoryPageIndex > 0;
  }

  get canShowDisplayCategoryNext(): boolean {
    return (
      (this.displayCategoryPageIndex + 1) * this.visibleCount <
      this.filteredDisplayCategoryTabs.length
    );
  }

  CrossTabName: string = COMMON_CONSTANTS.CrossTabModuleName;
  SnapShotName: string = COMMON_CONSTANTS.SnapShotModuleName;
  BrandAnalysisName: string = COMMON_CONSTANTS.BrandAnalysisModuleName;
  ArkName: string = COMMON_CONSTANTS.ARKName;
studyNameClicked:string='';
  studydropdown: boolean = false;
  Acrossdropdowncheck: boolean = false;
  isSnapshot: boolean = false;
  enableExplore: boolean = false;
  enableConfig: boolean = false;
  isCustomSnapshotWidgetLibrary: boolean = true;
  studyname: any = 'study Name';
  Acrossname: any = 'compare Across';
  filteredData: any[] = [];
  snapshotTiles: any[] = [];
  landingPageTilesData: any[] = [];
  popUpData: any;
  studyNamesCount: any = 0;
  studyNamesArray: any;
  filteredStudyNamesArray: any;
  searchStudyText: string = '';
  snapshotselected: any = '';
  sectionSelected: any = '';
  subsectinselected: any = '';
  exploreBtn: string = 'Explore';
  IsBrandAnalysis: boolean = false;
  snapshotType: any = [];

  @Input() moduleName: string = '';
  @Input() studyNames: any;
  @Input() studyName: any = '';
  @Input() ClientName: any;
  @Input() isSuperAdmin: any;
  @Input() configData: any;

  @ViewChild('searchInput') searchInput!: ElementRef;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private _loaderService: LoaderService,
    private _configService: SnapshotService,
    public SharedPopupService: SharedPopupService,
    private _configCustomService: CustomsnapshotService,
    private chatbotService: ChatbotService,
    private msalService: ClientssoService,
  ) {}

  ngOnInit() {
    this.studyNamesArray = this.studyNames ?? [];
    this.filteredStudyNamesArray = this.studyNamesArray;
    this.studyNamesCount = this.studyNamesArray.length;

    if (this.moduleName == this.SnapShotName) {
      this.studyname = 'Snapshot Name';
      this.getPopUpeData();
      this.toggleStudies(this.ClientName);
      this.isSnapshot = true;
      this.studyNamesArray.sort((a: string, b: string) =>
        a.trim().toLowerCase().localeCompare(b.trim().toLowerCase()),
      );
      this.studyNamesArray = this.studyNames ?? this.studyNamesArray;
      this.studyNamesArray.sort((a: string, b: string) =>
        a.trim().toLowerCase().localeCompare(b.trim().toLowerCase()),
      );
      this.studyNamesCount = this.studyNamesArray.length;
      this.filteredStudyNamesArray = this.studyNamesArray;

      if (this.useDisplayLandingLayout) {
        this.loadDisplayLandingData();
      } else if (!this.isSuperAdmin) {
        this._loaderService.showLoader();
        this._configService.getAllSnapshotData(this.ClientName).subscribe(
          (snapshots: any) => {
            if (snapshots) {
              let snapshotsRecord = JSON.parse(snapshots.Data);
              if (snapshotsRecord.length > 0) {
                this.studyNameclick(this.filteredStudyNamesArray[0]);
              } else {
                this.isCustomSnapshotWidgetLibrary = false;
              }
            }
            this._loaderService.hideLoader();
          },
          (err) => {
            console.error('Error fetching all snapshots:', err);
            this._loaderService.hideLoader();
          },
        );
      } else {
        this.studyNameclick(this.filteredStudyNamesArray[0]);
      }
    } else {
      this.isSnapshot = false;
      this.exploreBtn = this.isSuperAdmin ? this.exploreBtn : this.exploreBtn;
      this.studyname = this.studyName;
      if (!this.isSuperAdmin) {
        this.navigateToModule();
      }
    }
    this.updateVisibleCount();
    window.addEventListener('resize', this.resizeHandler);
  }
  isOpen = false;
  searchText = '';
  snapshots: Snapshot[] = [];

  loadLandingPageTiles(): Observable<any> {
    return this._configService.getLandingPageTiles().pipe(
      tap((data: any[]) => {
        this.landingPageTilesData = data;
      }),
      catchError(() => {
        console.error('Failed to load landing page tiles');
        return of(null);
      }),
    );
  }

  toggleSearch() {
    this.isOpen = !this.isOpen;
    this.searchText = '';
    if (this.isOpen) {
      setTimeout(() => this.searchInput.nativeElement.focus(), 0);
    }
  }

  get filteredSnapshots(): Snapshot[] {
    return this.snapshots.filter(
      (s) =>
        s.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
        s.section.toLowerCase().includes(this.searchText.toLowerCase()) ||
        s.subSection.toLowerCase().includes(this.searchText.toLowerCase()) ||
        s.type.toLowerCase().includes(this.searchText.toLowerCase()),
    );
  }

  highlightText(text: string): SafeHtml {
    if (!this.searchText) return text;
    text = this._configService.capitalizeWords(text);
    const search = this.searchText.trim();
    const regex = new RegExp(`(${search})`, 'gi');
    const result = text.replace(regex, `<mark>$1</mark>`);

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  combineHighlight(section: string, subSection: string): SafeHtml {
    const combined = `${section} - ${subSection}`;
    return this.highlightText(combined);
  }

  selectSnapshot(snapshot: any) {
    this.searchText = snapshot.name;
    this.isOpen = false;

    if (this.useDisplayLandingLayout) {
      const snapConfig = this.allConfiguredSnapshots.find(
        (s: any) =>
          s.snapshot_name?.toLowerCase() === snapshot.name?.toLowerCase(),
      );
      if (snapConfig) {
        const category = (snapConfig.category || '').trim();
        if (category) {
          const catIndex = this.filteredDisplayCategoryTabs.indexOf(category);
          if (catIndex >= 0) {
            this.displayCategoryPageIndex = Math.floor(
              catIndex / this.visibleCount,
            );
            this.displayCategoryTabClick(
              category,
              catIndex % this.visibleCount,
            );
          }
        }
        const tile: DisplaySnapshotTile = {
          snapshotName: snapshot.name,
          studyName: snapshot.name,
          category: snapConfig.category,
          bucket: snapConfig.bucket,
          displayLabel: snapshot.subSection || snapshot.section,
          navSnapshotType: snapshot.type,
          navSection: snapshot.section,
          navSubSection: snapshot.subSection || '',
          sort_id: this.getTileSortId(
            snapConfig.category,
            snapConfig.bucket,
            snapshot.section,
            snapshot.subSection || ''
          ),
        };
        this.onDisplayTileClick(tile);
        return;
      }
    }

    this.studyNameclick(snapshot.name);
    this.AcrossNameclick(snapshot.type, snapshot.section, snapshot.subSection);
  }

  activeIndex: number = 0;
  setActiveTab(index: number) {
    this.activeIndex = index;
  }

  getPopUpeData(): void {
    this.SharedPopupService.setPopUpTabData$.subscribe((data) => {
      if (data != null && data.data.length > 0) {
        this.popUpData = data.data;
        this.filteredData = data.data;
        this._configService.SnapshotList = data.data;
        if (
          this.isSnapshot &&
          this.useDisplayLandingLayout &&
          this.allConfiguredSnapshotsRaw.length > 0
        ) {
          this.applyDisplayLandingFromSnapshots(this.allConfiguredSnapshotsRaw);
        }
      }
    });
  }

  openstudyDropdown() {
    this.Acrossdropdowncheck = false;
    this.studydropdown = !this.studydropdown;
  }

  studyNameclick(name: any, index: number = 0) {
    this.activeIndex = this.pageIndex * this.visibleCount + index;

    this.studyname = name;
    this.studyNameClicked=name;
    if (!this.isSnapshot) {
      this.enableExplore = true;
    }

    this.enableConfig = true;
    this.Acrossname = 'compare Across';
    this.studydropdown = false;
    if (this.isSnapshot) {
      this.bindingAcrossDropdown();
    }
  }

  AcrossNameclick(snapshot_name: any, sectionname: any, subsection: any) {
    this.snapshotselected = snapshot_name;
    this.sectionSelected = sectionname;
    this.subsectinselected = subsection;
    this._configService.snapshotSelectedName = this.snapshotselected;
    this._configService.selectedSection = this.sectionSelected;
    this._configService.selectedSubSection = this.subsectinselected;
    this.Acrossdropdowncheck = false;
    if (subsection == '')
      this.Acrossname = snapshot_name.toUpperCase() + ' : ' + sectionname;
    else
      this.Acrossname =
        snapshot_name.toUpperCase() + ' : ' + sectionname + ' : ' + subsection;

    this.enableConfig = true;
    this.enableExplore = true;

    this.navigateToModule();
  }

  configuration() {
    if (this.isSnapshot) {
      if (this.studyname == 'Snapshot Name') {
        let data: { client_name: string; study: string; configdata: any } = {
          client_name: this.ClientName,
          study: '',
          configdata: this.filteredData,
        };
        this.router.navigateByUrl('Snapshot/configuaration', { state: data });
      } else {
        let data: {
          client_name: string;
          study: string;
          configdata: any;
          snapshotselected: string;
          sectionselected: any;
          subsectionselected: any;
        } = {
          client_name: this.ClientName,
          study: this.studyName,
          configdata: this.filteredData,
          snapshotselected: this.studyname,
          sectionselected: this._configService.selectedSection,
          subsectionselected: this._configService.selectedSubSection,
        };
        this.router.navigateByUrl('Snapshot/configuaration', { state: data });
      }
    } else {
      let data: { client_name: string; study: string } = {
        client_name: this.ClientName,
        study: this.studyName,
      };
      this.router.navigateByUrl('configuration', { state: data });
    }
  }

  toggleStudies(clickedClient: any): void {
    this.popUpData?.forEach((client: Client) => {
      if (client.ClientName !== clickedClient) {
        client.showStudies = false;
      } else {
        client.showStudies = true;
      }
    });
  }
  // bindingAcrossDropdown() {
  //   this._loaderService.showLoader();
  //   if (this.studyname != "study Name" && this.ClientName != '') {
  //     let snapshotData = {
  //       ClientName: this.ClientName,
  //       SnapshotName: this.studyname
  //     }
  //     this._configService
  //         .getClientStudyData({
  //           client_code: this.ClientName,
  //           snapshot_name: this.studyname,
  //         })
  //         .subscribe({
  //           next: (response) => {
  //             const data = JSON.parse(response.body?.Data ?? '{}');

  //             if (data?.snapshotType_details) {
  //               this.snapshotType = data.snapshotType_details;
  //             }
  //             if(data?.saveselection){
  //               this._configService.globalDefaultSelectionFlag = data.saveselection.find(
  //                 (item: { key: string; value: boolean }) => item.key === "Global Default Selection"
  //               )?.value ?? false;
  //             }
  //             this._configCustomService.getCustomSnapshotWidgetLibrary(snapshotData).subscribe((r: any) => {
  //               let data = r?.Data
  //               if(data) {
  //                 this.isCustomSnapshotWidgetLibrary = true;
  //                 let configuredSnapshotTypes = JSON.parse(data);
  //                 const snapshotTypeSet = new Set(
  //                   this.snapshotType.map((item: { snapshot_type: string }) => item.snapshot_type)
  //                 );

  //                 configuredSnapshotTypes.snapshotType = configuredSnapshotTypes.snapshotType.filter(
  //                   (item: { snapshotType_name: string }) =>
  //                     snapshotTypeSet.has(item.snapshotType_name)
  //                 );

  //                 const sortOrder = ['Single Brand', 'Multiple Brands', 'Multiple Markets'];
  //                 configuredSnapshotTypes.snapshotType.sort((a: any, b: any) => {
  //                   return sortOrder.indexOf(a.snapshotType_name) - sortOrder.indexOf(b.snapshotType_name);
  //                 });

  //                 this.AcrossDropdown = configuredSnapshotTypes?.snapshotType;
  //                 this._configService.AcrossDropdown = this.AcrossDropdown;
  //                 localStorage.setItem("AcrossDropdown", JSON.stringify(this.AcrossDropdown));

  //                 if (this.AcrossDropdown?.length) {
  //                   this.snapshots = [];
  //                   for (const dropdown of this.AcrossDropdown) {
  //                     for (const section of dropdown.section || []) {
  //                       const subsections = section.subsection || [];

  //                       if (subsections.length === 0 || subsections[0]?.subsection_name === 'NA') {
  //                         this.snapshots.push({
  //                           name: this._configService.capitalizeWords(this.studyname),
  //                           type: this._configService.capitalizeWords(dropdown.snapshotType_name),
  //                           section: this._configService.capitalizeWords(section.section_name),
  //                           subSection:"",
  //                         });
  //                       } else {
  //                         for (const subsection of subsections) {
  //                           this.snapshots.push({
  //                             name: this._configService.capitalizeWords(this.studyname),
  //                             type: this._configService.capitalizeWords(dropdown.snapshotType_name),
  //                             section: this._configService.capitalizeWords(section.section_name),
  //                             subSection: this._configService.capitalizeWords(subsection.subsection_name)
  //                           });
  //                         }
  //                       }
  //                     }
  //                   }
  //                 }
  //               } else{
  //                  this.isCustomSnapshotWidgetLibrary = false;
  //               }
  //               this._loaderService.hideLoader();
  //             },
  //               (error) => {
  //                 console.error('Error:', error);
  //                 this._loaderService.hideLoader();
  //               }
  //             );
  //           },
  //           error: (err) => {
  //             console.error('Error fetching client study data:', err);
  //             this._loaderService.hideLoader();
  //           }
  //         });
  //   }
  // }
  bindingSnapshotDropdown(snapshots: any) {
    if (!snapshots.Data) {
      this.isCustomSnapshotWidgetLibrary = false;
    }
    if (this.isCustomSnapshotWidgetLibrary) {
      const snapshotWidgetLibraryRecord = JSON.parse(snapshots.Data);
      this.snapshots = this.buildSearchSnapshots(snapshotWidgetLibraryRecord);
      const customSnapshotWidgetLibrary =
        this._configCustomService.getCustomSnapshotWidgetLibraryByName(
          this.studyname,
          this.ClientName,
        );
      if (customSnapshotWidgetLibrary) {
        this.handleLibraryData(customSnapshotWidgetLibrary);
      } else {
        console.warn('Library not found:', this.studyname);
        this.isCustomSnapshotWidgetLibrary = false;
      }
    }
  }
  bindingAcrossDropdown() {
    this._loaderService.showLoader();
    if (
      this.studyname != 'study Name' &&
      this.ClientName != '' &&
      this.studyname != ''
    ) {
      const snapshotData = {
        ClientName: this.ClientName,
        SnapshotName: this.studyname,
      };
      const cached = this._configService.getSnapshotByName(
        this.studyname,
        this.ClientName,
      );
      // if (cached) {
      //   this.processSnapshotData(cached, snapshotData);
      //   this._loaderService.hideLoader();
      // }

      //customising snapshot tiles change, hence not reading from cache
      if (true) {
        this._configService.getAllSnapshotData(this.ClientName).subscribe({
          next: (snapshots) => {
            const snapshot = this._configService.getSnapshotByName(
              this.studyname,
              this.ClientName,
            );
            if (snapshot) {
              this.processSnapshotData(snapshot, snapshotData);
            } else {
              console.warn('Snapshot not found:', this.studyname);
              this.isCustomSnapshotWidgetLibrary = false;
            }
            this._loaderService.hideLoader();
          },
          error: (err) => {
            console.error('Error fetching all snapshots:', err);
            this._loaderService.hideLoader();
          },
        });
      }
    } else {
      this._loaderService.hideLoader();
    }
  }
  processSnapshotData(data: any, snapshotData: any) {
    if (data?.snapshotType_details) {
      this.snapshotType = data.snapshotType_details;
    }
    if (data?.saveselection) {
      this._configService.globalDefaultSelectionFlag =
        data.saveselection.find(
          (item: { key: string; value: boolean }) =>
            item.key === 'Global Default Selection',
        )?.value ?? false;
    }

    this._configService.isCustomBaseSelected = data.isCustomBaseSelected;

    const customSnapshotWidgetLibrary =
      this._configCustomService.getCustomSnapshotWidgetLibraryByName(
        this.studyname,
        this.ClientName,
      );
    // if(customSnapshotWidgetLibrary){
    //   if(this.snapshots && this.snapshots.length == 0 && this._configCustomService.allCustomSnapshotWidgetLibrary.length > 0){
    //     this.snapshots = this.buildSearchSnapshots(this._configCustomService.allCustomSnapshotWidgetLibrary);
    //     this.isCustomSnapshotWidgetLibrary = true;
    //   }
    //   this.handleLibraryData(customSnapshotWidgetLibrary)
    // }

    //customising snapshot tiles change, hence not reading from cache
    if (true) {
      // this._configCustomService.getAllCustomSnapshotWidgetLibrary(this.ClientName, this.filteredStudyNamesArray)
      //   .subscribe({
      //     next: (snapshots:any) => {
      //       if(!snapshots.Data) {
      //         this.isCustomSnapshotWidgetLibrary = false;
      //       }
      //       if(this.isCustomSnapshotWidgetLibrary) {
      //         const snapshotWidgetLibraryRecord = JSON.parse(snapshots.Data);
      //         this.snapshots = this.buildSearchSnapshots(snapshotWidgetLibraryRecord);
      //         const customSnapshotWidgetLibrary = this._configCustomService.getCustomSnapshotWidgetLibraryByName(this.studyname, this.ClientName);
      //         if (customSnapshotWidgetLibrary) {
      //           this.handleLibraryData(customSnapshotWidgetLibrary);
      //         } else {
      //           console.warn("Library not found:", this.studyname);
      //           this.isCustomSnapshotWidgetLibrary = false;
      //         }
      //       }
      //       this._loaderService.hideLoader();
      //     },
      //     error: (err) => {
      //       console.error("Error fetching all Library:", err);
      //       this._loaderService.hideLoader();
      //     }
      //   });

      forkJoin({
        snapshotData:
          this._configCustomService.getAllCustomSnapshotWidgetLibrary(
            this.ClientName,
            this.filteredStudyNamesArray,
          ),
        tilesData: this.loadLandingPageTiles(),
      }).subscribe({
        next: ({ snapshotData }) => {
          this.bindingSnapshotDropdown(snapshotData);
          this._loaderService.hideLoader();
        },
        error: (err) => {
          console.error('Error loading data:', err);
          this._loaderService.hideLoader();
        },
      });
    }
  }

  buildSearchSnapshots(snapshotWidgetLibraryRecord: any[]): any[] {
    const snapshots: any[] = [];

    for (const item of snapshotWidgetLibraryRecord || []) {
      if (!item?.snapshotType?.length) continue;

      for (const dropdown of item.snapshotType) {
        for (const section of dropdown.section || []) {
          const subsections = section.subsection || [];

          if (
            subsections.length === 0 ||
            subsections[0]?.subsection_name === 'NA'
          ) {
            snapshots.push({
              name: item.snapshot_name,
              type: dropdown.snapshotType_name,
              section: section.section_name,
              subSection: '',
            });
          } else {
            for (const subsection of subsections) {
              snapshots.push({
                name: item.snapshot_name,
                type: dropdown.snapshotType_name,
                section: section.section_name,
                subSection: subsection.subsection_name,
              });
            }
          }
        }
      }
    }

    return snapshots;
  }

  handleLibraryData(libData: any) {
    this.isCustomSnapshotWidgetLibrary = true;
    let configuredSnapshotTypes = libData;
    const snapshotTypeSet = new Set(
      this.snapshotType.map(
        (item: { snapshot_type: string }) => item.snapshot_type,
      ),
    );

    configuredSnapshotTypes.snapshotType =
      configuredSnapshotTypes.snapshotType.filter(
        (item: { snapshotType_name: string }) =>
          snapshotTypeSet.has(item.snapshotType_name),
      );

    const sortOrder = [
      'Single Brand',
      'Multiple Brands',
      'Multiple Markets',
      'Audience Snapshot',
    ];
    configuredSnapshotTypes.snapshotType.sort((a: any, b: any) => {
      return (
        sortOrder.indexOf(a.snapshotType_name) -
        sortOrder.indexOf(b.snapshotType_name)
      );
    });

  }

  navigateToModule() {
    const finalStudyList = this.studyNamesArray ?? this.studyNames ?? [];
    let data: { client_code: string; study: string; studyList: any } = {
      client_code: this.ClientName,
      study: this.studyName,
      studyList: finalStudyList,
    };
    switch (this.moduleName) {
      case this.SnapShotName:
        this.navigateToSnapshot();
        break;
      case this.CrossTabName:
        this.router.navigateByUrl('Crosstab', { state: data });
        break;
      case this.BrandAnalysisName:
        this.router.navigateByUrl('BrandAnalysis', { state: data });
        break;
      case this.ArkName:
        this.navigateToArkWithAccessCheck(data);
        break;
    }
  }

  navigateToSnapshot() {
    const cached = this._configService.getSnapshotByName(
      this.studyname,
      this.ClientName,
    );
    if (cached) {
      this.handleNavigateSnapshot(cached);
    } else {
      this.subscriptions.add(
        this._configService
          .getClientStudyData({
            client_code: this.ClientName,
            snapshot_name: this.studyname,
          })
          .subscribe((b) => {
            const parsed = JSON.parse(b.body.Data);
            if (parsed) {
              this.handleNavigateSnapshot(parsed);
            } else {
              this.router.navigateByUrl('landing');
            }
          }),
      );
    }
  }

  navigateToArkWithAccessCheck(data: any) {
    let account = this.msalService.isAuthenticated();
    if (!account) {
      // const accounts = this.msalService.instance.getAllAccounts();
      // if (accounts && accounts.length > 0) {
      //   account = accounts[0];
      //   this.msalService.instance.setActiveAccount(account);
      // }
    }

    if (account) {
      this._loaderService.hideLoader();
      data['fromLandingPage'] = true;
      this.router.navigateByUrl('chatbotexpand', { state: data });
    } else {
      this._loaderService.hideLoader();
      data['fromLandingPage'] = true;
      this.router.navigateByUrl('chatbotexpand', { state: data });
    }
  }

  handleNavigateSnapshot(snapshot: any) {
    const mainStudy = snapshot.study_list[0].study_name;
    const data = {
      client_code: this.ClientName,
      study: this.studyname,
      main_study: mainStudy,
      study_category: snapshot.category || '',
      snapList: this._configService.SnapshotList?.filter(
        (a: any) => a.ClientName === this.ClientName,
      ),
      snapshotselected: this._configService.snapshotSelectedName,
      sectionselected: this._configService.selectedSection,
      subsectionselected: this._configService.selectedSubSection,
    };

    localStorage.setItem(
      'snapshotselected_landing',
      this._configService.snapshotSelectedName,
    );
    localStorage.setItem(
      'sectionselected_landing',
      this._configService.selectedSection,
    );
    localStorage.setItem(
      'subsectionselected_landing',
      this._configService.selectedSubSection,
    );

    // Navigate based on product
    const route =
      snapshot.product === 'Standard'
        ? 'Snapshot/snapshot-output'
        : 'Snapshot/custom-snapshot-output';

    this.router.navigateByUrl(route, { state: data });
  }

  pageIndex = 0; // which "page" of tabs we’re on
  // visibleCount =  4;
  // visibleCount = window.innerWidth > 1600 ? 5 : 4;
  visibleCount = 4;

  updateVisibleCount() {
    // this.visibleCount = window.innerWidth > 1600 ? 4 : 4;
    this.visibleCount = 4;
  }

  get visibleTabs() {
    const start = this.pageIndex * this.visibleCount;
    return this.filteredStudyNamesArray.slice(start, start + this.visibleCount);
  }

  selectTab(index: number) {
    this.activeIndex = index;
  }

  showPrev() {
    if (this.pageIndex > 0) {
      this.pageIndex--;
    }
  }

  showNext() {
    if (
      (this.pageIndex + 1) * this.visibleCount <
      this.filteredStudyNamesArray.length
    ) {
      this.pageIndex++;
    }
  }

  get canShowPrev() {
    return this.pageIndex > 0;
  }

  get canShowNext() {
    return (
      (this.pageIndex + 1) * this.visibleCount <
      this.filteredStudyNamesArray.length
    );
  }

  /**
   * Get description for a section based on header name and section name
   * Looks up from the landingPageTilesData
   */
  getDescription(headerName: string, sectionName: string): string {
    if (!this.landingPageTilesData || this.landingPageTilesData.length === 0) {
      return '';
    }

    // Find the current study data
    const currentStudy = this.landingPageTilesData.find(
      (study: any) =>
        study.study_name.toLowerCase() === this.studyname.toLowerCase(),
    );

    if (!currentStudy) return '';

    // Find the header
    const header = currentStudy.headers.find(
      (h: any) => h.header_name.toLowerCase() === headerName.toLowerCase(),
    );

    if (!header) return '';

    // Find the tile/section and return its description
    const tile = header.tiles.find(
      (t: any) => t.section_name.toLowerCase() === sectionName.toLowerCase(),
    );

    return tile ? tile.description : '';
  }

  getDescriptionForDisplayTile(tile: DisplaySnapshotTile): string {
    if (!this.landingPageTilesData?.length) return '';

    const normalize = (s: string) =>
      s.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();

    const study = this.landingPageTilesData.find(
      (s: any) => normalize(s.study_name) === normalize(tile.category)
    );
    if (!study) return '';

    const matchSection = (h: any): any =>
      h?.tiles?.find((t: any) => {
        const normSection = normalize(t.section_name);
        const normNav = normalize(tile.navSection);
        return normSection.includes(normNav) || normNav.includes(normSection);
      });

    // Try the tile's own bucket first, then fall back across all headers
    const targetHeader = study.headers.find(
      (h: any) => normalize(h.header_name) === normalize(tile.bucket)
    );
    const tileData = matchSection(targetHeader)
      ?? study.headers.reduce((found: any, h: any) => found ?? matchSection(h), null);

    return tileData?.description ?? '';
  }

  loadDisplayLandingData(): void {
    this._loaderService.showLoader();
    this._configService.getAllSnapshotData(this.ClientName).subscribe({
      next: (snapshots: any) => {
        if (!snapshots?.Data) {
          this.isCustomSnapshotWidgetLibrary = false;
          this._loaderService.hideLoader();
          return;
        }

        this.allConfiguredSnapshotsRaw = JSON.parse(snapshots.Data).filter(
          (snap: any) =>
            snap?.snapshot_name != null && snap.snapshot_name.trim() !== '',
        );

        this.allConfiguredSnapshots = this.filterSnapshotsByUserAccess(
          this.allConfiguredSnapshotsRaw,
        );

        if (this.allConfiguredSnapshots.length === 0) {
          this.isCustomSnapshotWidgetLibrary = false;
          this._loaderService.hideLoader();
          return;
        }

        const snapshotNames = this.allConfiguredSnapshots.map(
          (s: any) => s.snapshot_name,
        );

        forkJoin({
          libraries: this._configCustomService.getAllCustomSnapshotWidgetLibrary(
            this.ClientName,
            snapshotNames,
          ),
          tilesData: this.loadLandingPageTiles(),
        }).subscribe({
          next: () => {
            this.applyDisplayLandingFromSnapshots(this.allConfiguredSnapshotsRaw);
            this._loaderService.hideLoader();
          },
          error: (err) => {
            console.error('Error loading display landing data:', err);
            this.isCustomSnapshotWidgetLibrary = false;
            this._loaderService.hideLoader();
          },
        });
      },
      error: (err) => {
        console.error('Error fetching all snapshots:', err);
        this.isCustomSnapshotWidgetLibrary = false;
        this._loaderService.hideLoader();
      },
    });
  }

  private applyDisplayLandingFromSnapshots(allSnapshots: any[]): void {
    this.allConfiguredSnapshotsRaw = allSnapshots;
    this.allConfiguredSnapshots = this.filterSnapshotsByUserAccess(allSnapshots);
    this.initializeDisplayLanding();
  }

  initializeDisplayLanding(): void {
    this.buildDisplayCategoryTabs();
    this.buildDisplaySearchSnapshotsFromAll();
    this.isCustomSnapshotWidgetLibrary =
      this.displayCategoryTabs.length > 0 &&
      this.displayLandingGroupsHaveTiles();

    if (this.displayCategoryTabs.length > 0) {
      const activeStillValid = this.displayCategoryTabs.includes(
        this.activeDisplayCategory,
      );
      const preferredCategory = this.getPreferredDefaultDisplayCategory();
      const categoryToSelect = activeStillValid
        ? this.activeDisplayCategory
        : preferredCategory;
      const tabIndex = this.filteredDisplayCategoryTabs.indexOf(categoryToSelect);
      this.displayCategoryTabClick(
        categoryToSelect,
        tabIndex >= 0 ? tabIndex % this.visibleCount : 0,
      );
    } else {
      this.displayLandingGroups = [];
      this.isCustomSnapshotWidgetLibrary = false;
    }
  }

  private displayLandingGroupsHaveTiles(): boolean {
    return this.displayLandingGroups.some((g) => g.tiles.length > 0);
  }

  /**
   * Rows a bucket occupies in the 3-column tile grid. Used as the flex-grow of
   * the category block so the holder's spare height is split per row, keeping
   * every tile the same height regardless of how many tiles a bucket has.
   */
  getTileRowCount(bucketGroup: DisplayBucketGroup): number {
    return Math.max(1, Math.ceil((bucketGroup?.tiles?.length ?? 0) / 3));
  }

  private getPreferredDefaultDisplayCategory(): string {
    const selectedStudy = (this.studyNameClicked || this.studyName).trim();
    const hasSelectedStudy =
      !!selectedStudy &&
      selectedStudy.toLowerCase() !== 'snapshot name' &&
      selectedStudy.toLowerCase() !== 'study name';

    // If a study is selected, it controls the default tab.
    if (hasSelectedStudy) {
      const selectedIsProduct = selectedStudy
        .toLowerCase()
        .startsWith('product');

      if (
        selectedIsProduct &&
        this.displayCategoryTabs.includes('Product Tracker')
      ) {
        return 'Product Tracker';
      }

      if (this.displayCategoryTabs.includes('Brand Tracker')) {
        return 'Brand Tracker';
      }
    }

    if (this.displayCategoryTabs.includes('Brand Tracker')) {
      return 'Brand Tracker';
    }

    if (this.displayCategoryTabs.includes('Product Tracker')) {
      return 'Product Tracker';
    }

    return this.displayCategoryTabs[0];
  }

  isTileForSelectedStudy(tile: DisplaySnapshotTile): boolean {
    const normalize = (v: any) =>
      (v ?? '').toString().trim().toLowerCase();

    const tileSnapshot = normalize(tile?.studyName || tile?.snapshotName);
    if (!tileSnapshot) {
      return false;
    }

    // Primary match: if tile snapshot exists in the current study list, highlight it.
    const studies = Array.isArray(this.studyNamesArray)
      ? this.studyNamesArray
      : Array.isArray(this.studyNames)
        ? this.studyNames
        : [];

    const studySet = new Set(
      studies
        .map((item: any) =>
          normalize(typeof item === 'string' ? item : item?.SnapshotName),
        )
        .filter(Boolean),
    );

    if (studySet.has(tileSnapshot)) {
      return true;
    }

    // Fallback: support previously clicked study matching.
    const selectedStudy = normalize(this.studyNameClicked || this.studyName);
    if (
      !selectedStudy ||
      selectedStudy === 'study name' ||
      selectedStudy === 'choose study' ||
      selectedStudy === 'snapshot name'
    ) {
      return false;
    }

    return tileSnapshot === selectedStudy;
  }

  private getUserAccessibleSnapshotNames(): string[] {
    const fromPopup = this.extractAccessibleSnapshotNames(
      this.popUpData ?? this._configService.SnapshotList,
    );
    if (fromPopup.length > 0) {
      return fromPopup;
    }

    const configClients = Array.isArray(this.configData)
      ? this.configData
      : this.configData
        ? [this.configData]
        : [];
    const fromConfig = this.extractAccessibleSnapshotNames(configClients);
    if (fromConfig.length > 0) {
      return fromConfig;
    }

    const fallback = this.studyNamesArray ?? this.studyNames ?? [];
    if (Array.isArray(fallback)) {
      return fallback
        .map((item: any) =>
          typeof item === 'string' ? item : item?.SnapshotName,
        )
        .filter((name: string) => !!name?.trim());
    }

    if (fallback?.UniqueSnapshots?.length) {
      return this.extractAccessibleSnapshotNames([fallback]);
    }

    return [];
  }

  private extractAccessibleSnapshotNames(clients: any[] | null | undefined): string[] {
    if (!clients?.length || !this.ClientName) {
      return [];
    }

    const client = clients.find(
      (c: any) =>
        (c.ClientName || c.client_name || '').toLowerCase() ===
        this.ClientName.toLowerCase(),
    );

    if (!client?.UniqueSnapshots?.length) {
      return [];
    }

    return client.UniqueSnapshots.map((item: any) =>
      typeof item === 'string' ? item : item?.SnapshotName,
    ).filter((name: string) => !!name?.trim());
  }

  private filterSnapshotsByUserAccess(snapshots: any[]): any[] {
    const accessibleNames = this.getUserAccessibleSnapshotNames();
    if (!accessibleNames.length) {
      return [];
    }

    const accessibleSet = new Set(
      accessibleNames.map((name) => name.trim().toLowerCase()),
    );

    return snapshots.filter((snap: any) =>
      accessibleSet.has((snap.snapshot_name || '').trim().toLowerCase()),
    );
  }

  buildDisplayCategoryTabs(): void {
    const categoriesFromAccessibleSnapshots = new Set(
      this.allConfiguredSnapshots
        .map((s: any) => (s.category || '').trim())
        .filter((c: string) => !!c),
    );

    this.displayCategoryTabs = this.categoryDisplayOrder.filter((c) =>
      categoriesFromAccessibleSnapshots.has(c),
    );

    categoriesFromAccessibleSnapshots.forEach((c) => {
      if (!this.displayCategoryTabs.includes(c)) {
        this.displayCategoryTabs.push(c);
      }
    });

    this.filteredDisplayCategoryTabs = [...this.displayCategoryTabs];
    this.displayCategoryTabsCount = this.displayCategoryTabs.length;
    this.displayCategoryPageIndex = 0;
  }

  displayCategoryTabClick(category: string, index: number = 0): void {
    this.activeDisplayCategory = category;
    this.activeIndex = this.displayCategoryPageIndex * this.visibleCount + index;
    this.studydropdown = false;
    this.displayLandingGroups = this.buildDisplayLandingGroups(category);
    this.isCustomSnapshotWidgetLibrary =
      this.displayLandingGroups.some((g) => g.tiles.length > 0);
  }

  buildDisplayLandingGroups(category: string): DisplayBucketGroup[] {
    const snapshotsInCategory = this.allConfiguredSnapshots.filter(
      (snap: any) =>
        (snap.category || '').trim().toLowerCase() ===
        category.trim().toLowerCase(),
    );

    const groups: DisplayBucketGroup[] = [];

    for (const bucketName of this.bucketDisplayOrder) {
      const tiles: DisplaySnapshotTile[] = [];

      for (const snap of snapshotsInCategory) {
        if (
          (snap.bucket || '').trim().toLowerCase() !==
          bucketName.trim().toLowerCase()
        ) {
          continue;
        }

        tiles.push(...this.resolveSnapshotSectionTiles(snap));
      }

      if (tiles.length > 0) {
     
        tiles.sort((a, b) => (a.sort_id ?? 999) - (b.sort_id ?? 999));
        
        const bucketSortId = this.getBucketSortId(category, bucketName);
        groups.push({ bucketName, tiles, sort_id: bucketSortId });
      }
    }

    groups.sort((a, b) => (a.sort_id ?? 999) - (b.sort_id ?? 999));

    return groups;
  }

  private resolveSnapshotSectionTiles(
    snapshotConfig: any,
  ): DisplaySnapshotTile[] {
    const tiles: DisplaySnapshotTile[] = [];
    const lib = this._configCustomService.getCustomSnapshotWidgetLibraryByName(
      snapshotConfig.snapshot_name,
      this.ClientName,
    );
    if (!lib?.snapshotType?.length) {
      return tiles;
    }

    const snapshotTypeSet = new Set(
      (snapshotConfig.snapshotType_details || []).map(
        (d: any) => d.snapshot_type,
      ),
    );

    let types = lib.snapshotType;
    if (snapshotTypeSet.size > 0) {
      types = types.filter((t: any) =>
        snapshotTypeSet.has(t.snapshotType_name),
      );
    }

    const sortOrder = [
      'Single Brand',
      'Multiple Brands',
      'Multiple Categories',
      'Multiple Markets',
      'Audience Snapshot',
    ];
    types.sort(
      (a: any, b: any) =>
        sortOrder.indexOf(a.snapshotType_name) -
        sortOrder.indexOf(b.snapshotType_name),
    );

    for (const snapshotType of types) {
      for (const section of snapshotType.section || []) {
        const subsections = section.subsection || [];

        if (
          subsections.length === 0 ||
          subsections[0]?.subsection_name === 'NA'
        ) {
          const tileSortId = this.getTileSortId(
            snapshotConfig.category,
            snapshotConfig.bucket,
            section.section_name,
            ''
          );
          tiles.push({
            snapshotName: snapshotConfig.snapshot_name,
            studyName: snapshotConfig.snapshot_name,
            category: snapshotConfig.category,
            bucket: snapshotConfig.bucket,
            displayLabel: section.section_name,
            navSnapshotType: snapshotType.snapshotType_name,
            navSection: section.section_name,
            navSubSection: '',
            sort_id: tileSortId,
          });
        } else {
          for (const subsection of subsections) {
            const subName = subsection.subsection_name;
            const isNa = subName?.toLowerCase() === 'na';
            const tileSortId = this.getTileSortId(
              snapshotConfig.category,
              snapshotConfig.bucket,
              section.section_name,
              isNa ? '' : subName
            );
            tiles.push({
              snapshotName: snapshotConfig.snapshot_name,
              studyName: snapshotConfig.snapshot_name,
              category: snapshotConfig.category,
              bucket: snapshotConfig.bucket,
              displayLabel: isNa ? section.section_name : subName,
              navSnapshotType: snapshotType.snapshotType_name,
              navSection: section.section_name,
              navSubSection: isNa ? '' : subName,
              sort_id: tileSortId,
            });
          }
        }
      }
    }

    return tiles;
  }

  onDisplayTileClick(tile: DisplaySnapshotTile): void {
    this.studyname = tile.snapshotName;
    const snapshot = this._configService.getSnapshotByName(
      tile.snapshotName,
      this.ClientName,
    );
    if (snapshot?.snapshotType_details) {
      this.snapshotType = snapshot.snapshotType_details;
    }
    if (snapshot?.saveselection) {
      this._configService.globalDefaultSelectionFlag =
        snapshot.saveselection.find(
          (item: { key: string; value: boolean }) =>
            item.key === 'Global Default Selection',
        )?.value ?? false;
    }
    if (snapshot) {
      this._configService.isCustomBaseSelected = snapshot.isCustomBaseSelected;
    }

    this.AcrossNameclick(
      tile.navSnapshotType,
      tile.navSection,
      tile.navSubSection,
    );
  }


  private getBucketSortId(category: string, bucketName: string): number {
    if (!this.landingPageTilesData?.length) return 999;

    const normalize = (s: string) =>
      s.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();

    const study = this.landingPageTilesData.find(
      (s: any) => normalize(s.study_name) === normalize(category)
    );

    if (!study?.headers) return 999;

    const header = study.headers.find(
      (h: any) => normalize(h.header_name) === normalize(bucketName)
    );

    return header?.sort_id ?? 999;
  }


  private getTileSortId(
    category: string,
    bucketName: string,
    sectionName: string,
    subSectionName: string
  ): number {
    if (!this.landingPageTilesData?.length) return 999;

    const normalize = (s: string) =>
      s.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();

    const study = this.landingPageTilesData.find(
      (s: any) => normalize(s.study_name) === normalize(category)
    );

    if (!study?.headers) return 999;

    const header = study.headers.find(
      (h: any) => normalize(h.header_name) === normalize(bucketName)
    );

    if (!header?.tiles) return 999;

    const tile = header.tiles.find((t: any) => {
      const normSection = normalize(t.section_name);
      const normSectionMatch = normalize(sectionName);
      return normSection === normSectionMatch;
    });

    return tile?.sort_id ?? 999;
  }

  buildDisplaySearchSnapshotsFromAll(): void {
    this.snapshots = [];
    for (const snap of this.allConfiguredSnapshots) {
      for (const tile of this.resolveSnapshotSectionTiles(snap)) {
        if (!tile.navSnapshotType || !tile.navSection) {
          continue;
        }
        this.snapshots.push({
          name: snap.snapshot_name,
          type: tile.navSnapshotType,
          section: tile.navSection,
          subSection: tile.navSubSection,
        });
      }
    }
  }

  showDisplayCategoryPrev(): void {
    if (this.displayCategoryPageIndex > 0) {
      this.displayCategoryPageIndex--;
    }
  }

  showDisplayCategoryNext(): void {
    if (this.canShowDisplayCategoryNext) {
      this.displayCategoryPageIndex++;
    }
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    this.subscriptions.unsubscribe();
  }
}
